/** Personal-best labels for mode cards, HUD, and stats. */

export type ModeBestKind = "score" | "level" | "none";

const MODE_BEST_KIND: Record<string, ModeBestKind> = {
    normal: "score",
    progression: "level",
    wasd: "score",
    superdot: "score",
    roulette: "score",
    sandbox: "score",
    speedrun: "none",
    penalty: "none",
    highway: "score",
    darkness: "score",
    mirror: "score",
    snake: "score",
    combo: "score",
    overload: "score",
    colorrush: "score",
    heat: "score",
    hunter: "score",
    pop: "score",
    counter: "score",
    aim: "score",
    hook: "score",
    tilt: "score",
    orbit: "score",
    delay: "score",
    multiplayer: "none",
};

export function getModeBestKind(modeId: string): ModeBestKind {
    return MODE_BEST_KIND[modeId] ?? "none";
}

export function formatModeBestLine(modeId: string, value: number): string {
    const kind = getModeBestKind(modeId);
    const n = Math.max(0, Math.floor(Number(value) || 0));
    if (kind === "level") return n > 0 ? `Best Level: ${n}` : "Best Level: 0";
    if (kind === "score") return n > 0 ? `Best Score: ${n}` : "Best Score: 0";
    return "";
}

export const MODES_WITH_BEST_LINE = Object.entries(MODE_BEST_KIND)
    .filter(([, k]) => k !== "none")
    .map(([id]) => id);
